import { render, staticRenderFns } from "./ExportacaoConsolidada.vue?vue&type=template&id=952b5666"
import script from "./ExportacaoConsolidada.vue?vue&type=script&setup=true&lang=js"
export * from "./ExportacaoConsolidada.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports